import { render, staticRenderFns } from "./uyeRezervasyonlar.vue?vue&type=template&id=5ed3b552&scoped=true&"
import script from "./uyeRezervasyonlar.vue?vue&type=script&lang=js&"
export * from "./uyeRezervasyonlar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed3b552",
  null
  
)

export default component.exports